import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useAuthContext } from 'modules/auth/context';
import { getTestFeedback } from './api';

/** Per organization, so switching organization never shows another tenant's feedback from the cache. */
export const testFeedbackKey = (orgId: string | undefined, testId: string | undefined, page: number, limit: number) =>
  ['feedback', 'test', orgId, testId, page, limit] as const;

/** The anonymous feedback on one test, a page at a time. Keeps the previous page on screen while the next loads. */
export function useTestFeedback(testId: string | undefined, page: number, limit: number) {
  const { state } = useAuthContext();
  const orgId = state.organization?.id;
  return useQuery({
    queryKey: testFeedbackKey(orgId, testId, page, limit),
    queryFn: ({ signal }) => getTestFeedback(testId!, { page, limit }, signal),
    enabled: Boolean(testId),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
